<template>
  <transition :name="position === 'right' ? 'slide-fade-right' : 'slide-fade-left'">
    <div
      class="side-layout-bg"
      :style="[
        {
            'z-index': zIndex
        }]"
      @click.self.stop="close"
    >
        <slot name="sub"></slot>
        <div
            :style="[
            {
                width: width + 'px'
            }, {
                right: position === 'right' ? '0' : ''
            }, {
                left: position === 'left' ? '0' : ''
            }, {
                'box-shadow': position === 'right' ? '-10px 0 10px 0 rgba(0, 0, 0, 0.05)' : '10px 0 10px 0 rgba(0, 0, 0, 0.05)'
            }]"
            class="container"
            v-loading='isLoading'
        >
            <div class="header">
                <h2 v-if="headerTitle">{{headerTitle}}</h2>
                <p class="slot-header"><slot name="header"></slot></p>
                <i class="el-icon el-icon-close" @click="close"></i>
            </div>
            <main :style="[{
                bottom: isShowFooter ? '50px' : '0'
            }]">
                <slot></slot>
            </main>
            <footer v-if="isShowFooter">
                <div class="btn-box" v-if="isShowFooterBtn">
                    <el-button plain @click="cancel">{{cancelBtn}}</el-button>
                    <el-button type="primary" @click="confirm">{{confirmBtn}}</el-button>
                </div>
                <slot v-else name="footer"></slot>
            </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
    data() {
        return {}
    },
    props: {
        width: {
            default: 420,
            type: [String, Number]
        },
        headerTitle: {
            type: String
        },
        position: {
            default: "right",
            type: String
        },
        zIndex: {
            default: 1000,
            type: Number
        },
        isShowFooter: {
            default: true,
            type: Boolean
        },
        isShowFooterBtn: {
            default: true,
            type: Boolean
        },
        cancelBtn: {
            default: "取消",
            type: String
        },
        confirmBtn: {
            default: "确认",
            type: String
        },
        isLoading: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        close() {
            this.$emit("close")
        },
        cancel() {
            this.$emit("cancel")
        },
        confirm() {
            this.$emit("confirm")
        }
    }
}
</script>

<style lang="scss" scoped>
.side-layout-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1001;

    .container {
        position: absolute;
        top: 0;
        display: flex;
        flex-direction: column;
        width: 420px;
        bottom: 0;
        background: #fff;
        box-shadow: -10px 0 10px 0 rgba(0, 0, 0, 0.05);
        // z-index: 1;

        .header {
            flex: 0 0 50px;
            display: flex;
            align-items: center;
            width: 100%;
            background: #f2f2f2;

            .slot-header {
                font-size: 14px;
                color: #666;
            }

            h2 {
                margin: 0 10px;
                font-size: 16px;
                font-weight: bolder;
                color: #333;
            }

            i {
                position: absolute;
                right: 10px;
                font-size: 24px;
                color: #999;
                cursor: pointer;

                &:hover {
                    color: #009688;
                }
            }
        }

        main {
            flex: 1;
            width: 100%;
            overflow: auto;
        }

        footer {
            flex: 0 0 50px;
            display: flex;
            align-items: center;
            width: 100%;
            background: #fff;
            border-top: 1px solid #ebebeb;

            .btn-box {
                position: absolute;
                right: 10px;
                top: 6px;
                bottom: 0;

                .el-button {
                    // padding: 10px 30px;
                    width: 94px;
                    height: 36px;
                    padding: 0;
                }

                .el-button:nth-child(1) {
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                }

                .el-button:nth-child(2) {
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                }

                .el-button + .el-button {
                    margin: 0;
                }
            }
        }
    }
}

.slide-fade-right-enter-active {
    transition: all 0.3s ease;
}

.slide-fade-right-leave-active {
    transition: all 0.3s ease;
}

.slide-fade-right-enter,
.slide-fade-right-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
    //   transform: translateX(100%);
    opacity: 0;
}

.slide-fade-left-enter-active {
    transition: all 0.3s ease;
}

.slide-fade-left-leave-active {
    transition: all 0.3s ease;
}

.slide-fade-left-enter,
.slide-fade-left-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
    //   transform: translateX(-100%);
    opacity: 0;
}
</style>
